import http from "@mono/network";
import { getDeviceInfo } from "@mono/bridge";
import { APP_CHANNEL } from "@mono/constants";

const getSlotConfigInfo = async () => {
  const deviceInfo = await getDeviceInfo();
  return await http.get("/slot/getSlotConfigInfo", {
    params: {
      versionCode: deviceInfo ? deviceInfo.versionCode : 0,
      channel: deviceInfo ? deviceInfo.appChannel : APP_CHANNEL.GP,
      platform: deviceInfo ? deviceInfo.os : null,
      packageName: deviceInfo ? deviceInfo.packageName : null,
    },
  });
};

const spin = async (data) => {
  return await http.post("/slot/spin", data);
};

const getUserSlotInfoList = async (currentPage, pageSize = 20) => {
  return await http.get("/slot/getUserSlotInfoList", {
    params: {
      currentPage,
      pageSize,
    },
  });
};

/**
 * 获取金币数
 */
const getMyCoins = async (currencies) => {
  return await http.get(
    `/currency/get?currencies=${currencies}&seqId=` + new Date().getTime(),
    null
  );
};

/**
 * 拉取通用配置
 * @param {*} configs 配置id
 * @returns
 */
const getGlobalConfig = async (configs) => {
  return await http.post("config/getGlobalConfig", {
    seqid: 0,
    configs: configs,
  });
};

export default {
  getSlotConfigInfo,
  spin,
  getUserSlotInfoList,
  getMyCoins,
  getGlobalConfig
};
